import { SubTableColumn } from 'src/components/commons/subTable/types';

const COLUMNS: SubTableColumn[] = [
  {
    key: '',
    title: 'NAME',
    dataIndex: 'name',
    minWidth: 270,
    editable: true,
    dataType: 'string',
    unique: true,
    required: true,
    hidden: false,
    dataStructure: 'string',
    headerName: 'name',
    options: [],
    orderField: 'name',
    searchField: 'name',
  },
  {
    key: '',
    title: 'DESCRIPTION',
    dataIndex: 'description',
    editable: true,
    dataType: 'string',
    unique: false,
    required: false,
    minWidth: 200,
    hidden: false,
    dataStructure: 'string',
    headerName: 'description',
    options: [],
    orderField: 'description',
    searchField: 'description',
  },
];

export default COLUMNS;
